export const Config = Object.freeze({
  version: 30,
  apiUrl: "https://api.monitorgroningen.fstr.io/api",
  // apiUrl: 'http://windows:5682/api',
});



// WEBPACK FOOTER //
// ./src/app/classes/config.ts